// No Rub Club v2: scroll reveals and the bib-card "Add to cart" buttons.
// Content never depends on this file: without it every section is fully visible.
import { CartAddEvent } from '@theme/events';

/* reveal on scroll; anything already on screen is marked shown first, so the
   first screen never blinks out and back in */
const reveal = () => {
  for (const el of document.querySelectorAll('[data-nrc-reveal]:not(.is-in)')) {
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
  }
  document.documentElement.classList.add('nrc-js');
  const items = document.querySelectorAll('[data-nrc-reveal]:not(.is-in)');
  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      }
    },
    { rootMargin: '0px 0px 5% 0px', threshold: 0 }
  );
  items.forEach((el) => io.observe(el));
};

reveal();
document.addEventListener('shopify:section:load', reveal);

let ticking = false;
const sweep = () => {
  ticking = false;
  const limit = window.innerHeight * 1.05;
  for (const el of document.querySelectorAll('[data-nrc-reveal]:not(.is-in)')) {
    if (el.getBoundingClientRect().top < limit) el.classList.add('is-in');
  }
};
window.addEventListener('scroll', () => {
  if (!ticking) {
    ticking = true;
    requestAnimationFrame(sweep);
  }
}, { passive: true });
window.addEventListener('load', sweep);

/* bib card add to cart: same request and event as Fabric's own product form,
   so the cart drawer, cart count and free delivery bar all update together */
document.addEventListener('click', async (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-nrc-add]') : null;
  if (!btn) return;
  event.preventDefault();

  const id = Number(btn.dataset.nrcAdd);
  if (!id || btn.getAttribute('aria-busy') === 'true') return;

  const label = btn.querySelector('[data-nrc-label]');
  const original = label ? label.textContent : '';
  btn.setAttribute('aria-busy', 'true');

  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);

  try {
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sections.join(',') }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');

    document.dispatchEvent(
      new CartAddEvent({}, String(id), {
        source: 'nrc-card',
        itemCount: 1,
        productId: btn.dataset.productId,
        sections: data.sections,
      })
    );
    if (label) label.textContent = btn.dataset.added || 'Added';
  } catch (err) {
    console.error('[nrc] add to cart', err);
    if (label) label.textContent = 'Try again';
  } finally {
    btn.removeAttribute('aria-busy');
    setTimeout(() => {
      if (label) label.textContent = original;
    }, 2200);
  }
});
